/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from "styled-components";

import React from "react";
import { useSelector } from "react-redux";

import { getProductTitle } from "@components/OrderTaking/Helpers";

import "./index.css";

const CenteredTitle = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    padding: 10px;
`;
type WorkflowTitleType = {
    product: ProductType;
    currentWorkflow: any;
};
export function WorkflowTitle({
    product,
    currentWorkflow,
}: WorkflowTitleType): JSX.Element {
    const { globalcard } = useSelector((state) => (state as any).orderSlice);
    const title = currentWorkflow
        ? getProductTitle(
              globalcard?.items?.[
                  currentWorkflow?.workflow[currentWorkflow.index]?.iuudproduct
              ]?.name
          )
        : "";

    return (
        <CenteredTitle className=" d-flex justify-content-center align-items-center  w-100">
            <div className="d-flex flex-column align-items-center">
                <div
                    key={title + "1"}
                    className="workflow-product-title preview-text"
                >
                    {title}
                </div>

                {product?.selectedOptions?.length > 0 && (
                    <div className="info-options-product">
                        {product?.selectedOptions.join(",")}
                    </div>
                )}
            </div>
        </CenteredTitle>
    );
}
